/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import PartnerForm from '../../components/partnermng/PartnerForm';
import client from '../../lib/api/client';
import { useDispatch, useSelector } from 'react-redux';
import { setPartner } from '../../modules/partnerModule/partner';
import * as fileApi from '../../lib/api/file';
import { listPartnerfiles } from '../../modules/partnerModule/files';

const PartnerFormContainer = ({ type, handleClose, isModal }) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { partner } = useSelector(({ partnerModule }) => ({
    partner: partnerModule.partner.partner,
  }));

  const initialValues = {
    partnerTyp: partner?.partnerTyp ?? '',
    incTyp: partner?.incTyp ?? '',
    partnerNm: partner?.partnerNm ?? '',
    president: partner?.president ?? '',
    regNumber: partner?.regNumber ?? '',
    mainItemDesc: partner?.mainItemDesc ?? '',
    businessStatus: partner?.businessStatus ?? '',
    businessTyp: partner?.businessTyp ?? '',
    partnerPhone: partner?.partnerPhone ?? '',
    accountOpenDate: partner?.accountOpenDate ?? '',
    bankName: partner?.bankName ?? '',
    accountNumber: partner?.accountNumber ?? '',
    partnerAddr: partner?.partnerAddr ?? '',
    partnerDesc: partner?.partnerDesc ?? '',
    taxEmail: partner?.taxEmail ?? '',
    companyCBR: null ?? '',    
    copyBankBook: null ?? '',  
    file: null,
    target: null,
  };

  const validationSchema = yup.object({
    partnerTyp:      yup.string().required('거래처타입을 선택하세요'),
    incTyp:          yup.string().required('산업체 유형을 선택하세요'),
    partnerNm:       yup.string().required('고객명을 입력하세요'),
    president:       yup.string().required('대표자명을 입력하세요'),
    regNumber:       yup
                      .string()
                      .required('사업자번호를 입력하세요')
                      .min(12, '사업자번호를 확인하세요')
                      .max(12, '사업자번호를 확인하세요'),
    mainItemDesc:    yup.string().nullable(),
    businessStatus:  yup.string().nullable(),
    businessTyp:     yup.string().nullable(),
    partnerPhone:    yup.string().required('연락처를 입력하세요'),
    accountOpenDate: yup.string().required('거래게시일을 선택하세요'),
    bankName:        yup.string().nullable(),
    accountNumber:   yup.string().nullable(),
    partnerAddr:     yup.string().required('주소를 입력하세요'),
    partnerDesc:     yup.string().nullable(),
  });
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(type, values);
      formik.resetForm();
      setSubmitting(false);
    },
  });

  const onSaveFile = async (values, partnerUuid) => {
    let fileNumSt = 0;
    let fileNumEd = 2;
    
    if(values.companyCBR === '' && values.copyBankBook === '' ) {
      return;
    }
    
    if(values.companyCBR === '') {
      fileNumSt = 1;
    } 
    
    if(values.copyBankBook === '') {
      fileNumEd = 1;
    }

    for(let i = fileNumSt; i < fileNumEd; i++) {
      let fileValue = '';
      let fileAddName = '';
      if(i == 0) {
        fileValue = values.companyCBR;
        fileAddName = '사업자등록증';
      } else {
        fileValue = values.copyBankBook;
        fileAddName = '통장사본';
      }
      let formData = new FormData();
      formData.append('fileDt', fileValue);
      formData.append('fileTyp', 'partner');
      formData.append('fileAttrVal1', partnerUuid);
      formData.append('fileAttrVal2', fileAddName);

      try {
        const response = await fileApi.addFiles(formData);
        if (response.data) {
          dispatch(listPartnerfiles('partner', partnerUuid));
          enqueueSnackbar(fileAddName+' 파일이 등록되었습니다.', {
            variant: 'success',
          });
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }
    }
  };
  
  const onSave = (type, values) => {
    const dataToSubmit = {
      partnerTyp:      values.partnerTyp,
      incTyp:          values.incTyp,
      partnerNm:       values.partnerNm.trim(),
      president:       values.president.trim(),
      regNumber:       values.regNumber,
      mainItemDesc:    values.mainItemDesc,
      businessStatus:  values.businessStatus,
      businessTyp:     values.businessTyp,
      partnerPhone:    values.partnerPhone,
      accountOpenDate: values.accountOpenDate,
      bankName:        values.bankName,
      accountNumber:   values.accountNumber,
      partnerAddr:     values.partnerAddr,
      partnerDesc:     values.partnerDesc,
      taxEmail:        values.taxEmail,
    };

    if (type === 'add') {
      client
        .post(`/api/v1/master/partner/info`, dataToSubmit)
        .then((res) => {
          if (res.data.result === 'success') {
            onSaveFile(values, res.data.info.partnerUuid);
            
            if (isModal && typeof handleClose === 'function') {
              handleClose();
            } else {
              navigate(`/partnermng/${res.data?.info?.partnerUuid}`);
            }

            enqueueSnackbar('거래처가 추가되었습니다', {
             variant: 'success',
            });
          } else {
            enqueueSnackbar(res.data?.message, {
              variant: 'error',
            });
          }
        })
        .catch((err) => {
          let message =
            typeof err.response !== 'undefined'
              ? err.response.data.message
              : err.message;
          enqueueSnackbar(message, {
            variant: 'error',
          });
        });
    } else {
      dataToSubmit.partnerUuid = partner.partnerUuid;

      client
        .put(`/api/v1/master/partner/info/${partner.partnerUuid}`, dataToSubmit)
        .then((res) => {
          onSaveFile(values, res.data.info.partnerUuid);
          dispatch(setPartner(res.data.info));
          enqueueSnackbar('거래처가 수정되었습니다', {
            variant: 'success',
          });
        })
        .catch((err) => {
          let message =
            typeof err.response !== 'undefined'
              ? err.response.data.message
              : err.message;
          enqueueSnackbar(message, {
            variant: 'error',
          });
        });
    }
  };

  return <PartnerForm formik={formik} type={type} />;
};

export default PartnerFormContainer;
